import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';
import { restaurantApplicationsStoreMock } from 'services/mock/utils/restaurantApplicationsModel';

export const getNewRestaurantApplicationsCount = async () => {
  await asyncTimeout(SERVICES_MOCK_DELAY);

  return restaurantApplicationsStoreMock.getAllNewApplications().length;
};
